import { Component, Input, OnInit } from '@angular/core';
import { HeaderService, HeaderConfig } from '../../../../services/header/header.service'; // Import HeaderConfig from HeaderService
import {ActivatedRoute, Router} from '@angular/router';
import {environment} from "../../../../../environments/environment.prod";
import {ProductsService} from "../../../../services/products/products.service";
import {PaginatedResponse} from "../../../../models/paginatedResponse";
import {Product} from "../../../../models/Product";
import {ToastrService} from "ngx-toastr";
import {StockService} from "../../../../services/stock/stock.service";



@Component({
    selector: 'app-detail-product',
    templateUrl: './detail-product.component.html',
    styleUrls: ['./detail-product.component.scss']
})
export class DetailProductComponent implements OnInit {
    currentStep: number = 1;
    productData: any = {};
    activeTab: string = 'overview';
    isStep1Valid: boolean = false;
    searchText = '';
    file: string = environment.file_url;
    @Input() config!: HeaderConfig; // Use HeaderConfig from HeaderService
    productId!: number;
    totalQuantity: number = 0;
    /** Alerte : au moins une ligne logistique avec is_active_alert et stock total nul (API total_quantity). */
    showEmptyStockAlert = false;

    constructor(
        private headerService: HeaderService, private route: ActivatedRoute, private productsService : ProductsService ,
        private router: Router ,private toastr: ToastrService, private stockService: StockService
    ) {}

    ngOnInit(): void {
        this.productId = +this.route.snapshot.paramMap.get('id')!;
        this.headerService.setConfig({
            title: 'Détails du Produit',
            buttons: [
                {
                    label: 'Modifier',
                    action: () => this.handleModifierClick(this.productId),
                    type: 'secondary'
                },
                {
                    label: 'Retour',
                    action: () => this.router.navigate(['/produits-services']),
                    type: 'secondary'
                }
            ]
        });

        this.headerService.config$.subscribe(config => {
            if (config) {
                this.config = config;
            }
        });

        // Initialize productData with default values
      this.getProduct();
    }

    getProduct(): void {
        this.productsService.getDetailsProduct(this.productId).subscribe({
            next: (response: Product) => {
                this.productData = this.unwrapProductResponse(response);
                // Stock : résolution id module stock (GET .../products/product-id/:erpId) puis total_quantity (GET .../stock/product/:id?user_id&station_id)
                this.loadStockQuantity();
            },
            error: (err) => {
                this.toastr.error('Erreur lors du chargement du produit');
            }
        });
    }

    /** Bloc « Référence fabricant » : ref_fabricant, repli ref_interne si vide. */
    getRefFabricantDisplay(): string {
        const p = this.productData;
        const fabRaw = p?.ref_fabricant ?? p?.ref_fabriquant;
        const fab = fabRaw != null ? String(fabRaw).trim() : '';
        if (fab !== '') {
            return fab;
        }
        const ri = p?.ref_interne != null ? String(p.ref_interne).trim() : '';
        return ri !== '' ? ri : '—';
    }

    /** Certaines API renvoient { data: product } au lieu du produit à la racine. */
    private unwrapProductResponse(res: any): any {
        if (!res || typeof res !== 'object') {
            return {};
        }
        const inner = res.data ?? res.product ?? res.produit;
        if (inner && typeof inner === 'object' && !Array.isArray(inner)) {
            return inner;
        }
        return res;
    }

    private getInformationsLogistiqueArray(p: any): any[] {
        if (!p) {
            return [];
        }
        const raw =
            p.informations_logistique ??
            p.information_logistique ??
            p.informationsLogistique ??
            p.product?.informations_logistique;
        return Array.isArray(raw) ? raw : [];
    }

    private isProductMaterial(p: any): boolean {
        const t = (p?.type ?? '').toString().trim().toLowerCase();
        return t === 'matériel' || t === 'materiel' || t === 'material';
    }

    /** Backend : is_active_alert | is_active_alerte ; 1 / "1" / true. */
    private isLogisticAlertEnabled(line: any): boolean {
        if (!line || typeof line !== 'object') {
            return false;
        }
        const v = line.is_active_alert ?? line.is_active_alerte ?? line.active_alert;
        if (v === true || v === 1 || v === '1') {
            return true;
        }
        if (v === false || v === 0 || v === '0' || v === '') {
            return false;
        }
        return !!v;
    }

    loadStockQuantity(): void {
        this.stockService.getTotalStockByErpProductId(this.productId).subscribe({
            next: (totalQuantity: number) => {
                this.totalQuantity = totalQuantity;
                this.updateEmptyStockAlert();
            },
            error: (err) => {
                console.error('Erreur lors de la récupération du stock:', err);
                this.totalQuantity = 0;
                this.updateEmptyStockAlert();
            }
        });
    }

    private updateEmptyStockAlert(): void {
        const qty = this.totalQuantity == null || isNaN(Number(this.totalQuantity)) ? 0 : Number(this.totalQuantity);
        const logistics = this.getInformationsLogistiqueArray(this.productData);
        const isMaterial = this.isProductMaterial(this.productData);
        const alertRequested = logistics.some((w) => this.isLogisticAlertEnabled(w));
        this.showEmptyStockAlert = isMaterial && alertRequested && qty <= 0;
    }


    // --- Step Navigation Logic ---
    nextStep(): void {
        if (this.currentStep < 4) {
            this.currentStep++;
        }
    }

    selectTab(tabName: string): void {
        this.activeTab = tabName;
    }

    goBack(): void {
        if (this.currentStep > 1) {
            this.currentStep--;
        }
    }

    // --- Validation Logic for Each Step ---
    validateStep1(): void {
        this.isStep1Valid = !!this.productData.type;
    }

    validateAndNextStep2(): void {
        this.nextStep();
    }

    // --- Image Upload Handler ---
    onFileSelected(event: any): void {
        const file: File = event.target.files[0];
        if (file) {
            //console.log('Selected file:', file.name);
        }
    }

    // --- Final Actions (Step 4) ---
    addNewProduct(): void {
        this.currentStep = 1;
        this.productData = {};
        this.isStep1Valid = false;
    }

    viewProduct(): void {
        console.log('Navigate to view product details for:', this.productData.name);
    }

    quickAdd(): void {
        console.log('Quick Add initiated with data:', this.productData);
        this.currentStep = 4;
    }



    handleModifierClick(productId: number) {
        this.router.navigate(['/produits-services/modifier-produit', productId], {
            queryParams: { step: 1 },
            state: { fromDetail: true }
        });
    }


    protected readonly Object = Object;
}
